'use client';

import { defineMessages, useIntl } from 'react-intl';
import { Select, SelectContent, SelectItem } from '@packages/shared/src/ui/Select/Select';

const messages = defineMessages({
  days30: {
    id: 'PeriodFilter.30days',
    defaultMessage: '30 Tage',
    description: '30 days filter option',
  },
  days120: {
    id: 'PeriodFilter.120days',
    defaultMessage: '120 Tage',
    description: '120 days filter option',
  },
});

export const DEFAULT_MAX_AGE_DAYS = 30;

export interface PeriodFilterProps {
  value: number;
  onChange: (maxAgeDays: number) => void;
  label: string;
}

const getDaysSince = (date: Date): number => {
  const today = new Date();
  return Math.ceil((today.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
};

export const PeriodFilter = ({ value, onChange, label }: PeriodFilterProps) => {
  const { formatMessage } = useIntl();

  const currentYear = new Date().getFullYear();
  const daysCurrentYear = getDaysSince(new Date(currentYear, 0, 1));
  const daysLastYear = getDaysSince(new Date(currentYear - 1, 0, 1));

  const handleChange = (stringValue: string) => {
    onChange(parseInt(stringValue, 10));
  };

  return (
    <Select
      label={label}
      value={value.toString()}
      onValueChange={handleChange}
      containerClassName="w-full"
    >
      <SelectContent>
        <SelectItem value="30">{formatMessage(messages.days30)}</SelectItem>
        <SelectItem value="120">{formatMessage(messages.days120)}</SelectItem>
        <SelectItem value={daysCurrentYear.toString()}>{currentYear}</SelectItem>
        <SelectItem value={daysLastYear.toString()}>{currentYear - 1}</SelectItem>
      </SelectContent>
    </Select>
  );
};
